<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              v-if="UserData.role !== 'zean'"
              class="navbar-brand"
              to="/"
            >
              <h2 class="text-primary">
                <cogs-icon />
                {{ $store.state.app.agent ? $store.state.app.agent.site_name : 'Nokplus Admin' }}
              </h2>
            </b-link>
            <h2
              v-else
              class="text-primary mt-2 ml-1"
            >
              {{ $store.state.app.agent ? $store.state.app.agent.site_name : 'Nokplus Admin' }}
            </h2>
          </li>

          <!-- Toggler Button -->
          <!-- <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle bg-btn-toggle">
              <i
                :class="collapseTogglerIconFeather"
                @click="toggleCollapsed"
              />
            </b-link>
          </li> -->
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import navMenuItems from '@/navigation/vertical'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import { computed, provide, ref } from '@vue/composition-api'
import { BLink } from 'bootstrap-vue'
import CogsIcon from 'vue-material-design-icons/Cogs.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    CogsIcon,
    // BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'fas fa-chevron-double-left' : 'fas fa-chevron-double-right'))

    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },
  data() {
    return {
      agent: {},
      UserData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  mounted() {
    // console.log(this.$http)
    if (this.UserData.role === 'zean') {
      this.getAgentZean()
    } else {
      // this.getAgent()
    }
  },
  methods: {
    getAgentZean() {
      this.$http
        .get('/zean/agent/show')
        .then(response => {
          this.agent = response.data
          // this.switch(response.data)
          // console.log(response.data)
        })
        .catch(error => console.log(error))
    },
    getAgent() {
      this.$http
        .get('/agent/show')
        .then(response => {
          this.agent = response.data
          // this.switch(response.data)
          // console.log(response.data)
        })
        .catch(error => console.log(error))
    },
  },
}
</script>

<style lang="scss" scoped>
.animate-charcter
{
  font-family: 'Russo One', sans-serif;
   text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #ffffff 0%,
    #BE68AA 29%,
    #8B55A3 67%,
    #5A499D 100%
  );
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  // font-weight: 600 !important;
  font-size: 30px;
}
@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
h3 {
  font-family: 'Russo One', sans-serif;
  margin-top: 5px;
  // font-weight: 600;
  font-size: 30px;
  color: #ffff
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@700&family=Russo+One&display=swap');
@import '~@core/scss/base/core/menu/menu-types/vertical-menu.scss';

</style>
